import * as React from 'react';
import { VideoPlayerConstants } from '../constants';
import { VideoPreloadEnums } from '../enums';
import { MimeType } from "../../../common";
import { StyledVideoDocument, StyledVideoDownload } from './VideoPlayer.style';
export const VideoPlayer = ({ videoSourceUrl, isDownloadEnabled, playerId = VideoPlayerConstants.DEFAULT_PLAYER_ID, playerWidth = VideoPlayerConstants.VIDEO_PLAYER_DEFAULT_SIZE, thumbnailImage = '', preload = VideoPreloadEnums.NONE, isAutoPlayEnabled = false, mimeType, onPlay, onPause, shouldDisablePictureInPicture = false, shouldDisableRemotePlayBack = false, shouldDisablePlayBackRate = false }) => {
    const [isVideoSupported, setIsVideoSupported] = React.useState(true);
    React.useEffect(() => {
        setIsVideoSupported(mimeType === MimeType.VIDEO_MP4 || mimeType === MimeType.VIDEO_MOV);
    }, [mimeType]);
    const onVideoDownload = () => {
        let fileName = '';
        fetch(videoSourceUrl)
            .then((response) => {
            if (response && response.url) {
                const queryStrippedUrl = response.url.split('?')[0];
                if (queryStrippedUrl) {
                    const urlParts = queryStrippedUrl.split('/');
                    if (urlParts.length > 0) {
                        fileName = urlParts[urlParts.length - 1];
                    }
                }
            }
            return response.blob();
        })
            .then((fileBlob) => {
            // Create a temporary URL for the blob
            const objectUrl = window.URL.createObjectURL(fileBlob);
            // Create and configure a temporary download link
            const downloadLink = document.createElement('a');
            downloadLink.style.display = 'none';
            downloadLink.href = objectUrl;
            if (fileName) {
                downloadLink.download = fileName;
            }
            // Append to DOM, trigger click and clean up
            document.body.appendChild(downloadLink);
            downloadLink.click();
            window.URL.revokeObjectURL(objectUrl);
            document.body.removeChild(downloadLink); // Added cleanup to remove the element
        })
            .catch((error) => console.error('Video download failed:', error));
    };
    const onVideoPlay = () => onPlay && onPlay();
    const onVideoPause = () => onPause && onPause();
    const displayOption = isDownloadEnabled ? (React.createElement(StyledVideoDownload, { className: "mi-icon-download-cloud", id: playerId, onClick: onVideoDownload })) : (React.createElement(StyledVideoDocument, { className: "mi-icon-document-movie", id: playerId }));
    const controlsList = `${isDownloadEnabled ? VideoPlayerConstants.DOWNLOAD : VideoPlayerConstants.NO_DOWNLOAD} ${shouldDisableRemotePlayBack ? VideoPlayerConstants.NO_REMOTE_PLAY_BACK : ''} ${shouldDisablePlayBackRate ? VideoPlayerConstants.NO_PLAY_BACK_RATE : ''}`;
    return isVideoSupported ? (React.createElement("video", { key: videoSourceUrl, id: playerId, controls: true, preload: preload, disablePictureInPicture: shouldDisablePictureInPicture, controlsList: controlsList, poster: thumbnailImage, width: playerWidth, onPlay: onVideoPlay, onPause: onVideoPause, autoPlay: isAutoPlayEnabled },
        React.createElement("source", { src: videoSourceUrl }))) : (displayOption);
};
//# sourceMappingURL=VideoPlayer.js.map